<template>
<panel>
  <p slot="header">
    Dodaj e-mail
  </p>
  <p slot="actions">
    <ui-button type="flat" icon="navigate_before" color="primary" @click.prevent="$router.push({name: 'admin.emails.dashboard'})">Wróć</ui-button>
  </p>
  <emails-form :item="item"></emails-form>
</panel>

</template>
<script>
import Emails from './../../services/Emails'

export default {
  data () {
    return {
      item: Emails.getBaseItem()
    }
  },
  mounted () {
  }
}

</script>


// WEBPACK FOOTER //
// Create.vue?5b54c554